import { FC } from 'react'
import { AlertTemplateProps } from 'react-alert'

import { cn } from '@bem-react/classname'

import { parseAlertString } from '@/utils/parseAlertString'

import './AlertTemplate.scss'

const cnAlertTemplate = cn('AlertTemplate')

interface IAlertTemplate extends AlertTemplateProps {
  className?: string
}

export const AlertTemplate: FC<IAlertTemplate> = ({
  className,
  style,
  options,
  message,
  close,
}: IAlertTemplate) => {
  const obj =
    typeof message === 'string' && message.includes('|')
      ? parseAlertString(message)
      : null

  return (
    <div className={cnAlertTemplate(null, [className])}>
      <div className={cnAlertTemplate('wrap')} style={style}>
        <div className={cnAlertTemplate('icon')}>
          {options.type === 'info' && '👋'}
          {options.type === 'success' && '🎉'}
          {options.type === 'error' && '🥵'}
        </div>

        {obj ? (
          <div className={cnAlertTemplate('message')}>
            <div
              className={cnAlertTemplate('title', {
                success: options.type === 'success',
                error: options.type === 'error',
              })}
            >
              {obj.title}
            </div>
            <div className={cnAlertTemplate('text')}>{obj.text}</div>
          </div>
        ) : (
          <div className={cnAlertTemplate('text')}>{message}</div>
        )}

        <button onClick={close} className={cnAlertTemplate('btn')}>
          <svg
            width='18'
            height='18'
            viewBox='0 0 18 18'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
          >
            <g opacity='0.3' clipPath='url(#clip0_31_2221)'>
              <path
                d='M4.06152 14.3618C3.95573 14.256 3.8859 14.1333 3.85205 13.9937C3.8182 13.854 3.8182 13.7144 3.85205 13.5747C3.8859 13.4351 3.95361 13.3145 4.05518 13.2129L7.83838 9.42334L4.05518 5.64014C3.95361 5.54281 3.8859 5.42432 3.85205 5.28467C3.82243 5.14079 3.82243 4.99902 3.85205 4.85938C3.8859 4.71973 3.95573 4.59701 4.06152 4.49121C4.16309 4.38542 4.28369 4.31559 4.42334 4.28174C4.56722 4.24788 4.70898 4.24788 4.84863 4.28174C4.99251 4.31559 5.11523 4.3833 5.2168 4.48486L9 8.26807L12.7832 4.48486C12.8848 4.3833 13.0054 4.31559 13.145 4.28174C13.2847 4.24788 13.4243 4.24788 13.564 4.28174C13.7036 4.31559 13.8263 4.38753 13.9321 4.49756C14.0379 4.59912 14.1077 4.71973 14.1416 4.85938C14.1797 4.99902 14.1797 5.13867 14.1416 5.27832C14.1077 5.41797 14.04 5.53857 13.9385 5.64014L10.1616 9.42334L13.9385 13.2129C14.04 13.3145 14.1077 13.4351 14.1416 13.5747C14.1755 13.7144 14.1755 13.854 14.1416 13.9937C14.1077 14.1333 14.0379 14.256 13.9321 14.3618C13.8263 14.4676 13.7036 14.5374 13.564 14.5713C13.4243 14.6051 13.2847 14.6051 13.145 14.5713C13.0054 14.5374 12.8848 14.4697 12.7832 14.3682L9 10.585L5.2168 14.3682C5.11523 14.4697 4.99463 14.5374 4.85498 14.5713C4.71533 14.6051 4.57357 14.6051 4.42969 14.5713C4.29004 14.5374 4.16732 14.4676 4.06152 14.3618Z'
                fill='white'
                fillOpacity='0.45'
              />
            </g>
            <defs>
              <clipPath id='clip0_31_2221'>
                <rect width='18' height='18' fill='white' />
              </clipPath>
            </defs>
          </svg>
        </button>
      </div>
    </div>
  )
}
